module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C101"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgments#page_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C108"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface__Why_Cuba#page_xiii"
    }
  }, [_vm._v("Preface: Why Cuba?")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction__In_Pursuit_of_Adeq#page_1"
    }
  }, [_vm._v("Introduction: In Pursuit of Adequacy")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__La_Lucha#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("La Lucha")])])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_2__Antes#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Antes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Virtuous_Womanhood#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Virtuous Womanhood")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Community#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Community")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__Breakdown#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Breakdown")])]), _vm._v(" "), _c('p', {
    staticClass: "C108"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Conclusion__The_Politics_of_Adeq#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Politics of Adequacy")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Notes#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_References#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Index#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0